<template>
    <div style="margin-left:50px;">
  
            <el-form style="display: flex;flex-wrap: wrap;">
                <el-form-item label="添加人:" style="display: flex;width: 33%;">
                    <el-select placeholder="请选择添加人" v-model="input1" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="添加时间:" style="display: flex;width: 50%;" >
                    <!-- <el-date-picker style="width: 100%"  v-model="input2" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" clearable></el-date-picker> -->
                    <el-date-picker
                        style="width: 100%;"
                        v-model="input2"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        clearable>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="模版名称:" style="display: flex;width: 33%;" >
                    <el-input v-model="input3" type="text"  placeholder="请输入模版名称"></el-input>
                    <!-- <el-select placeholder="请选择模版名称" v-model="input3" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select> -->
                </el-form-item>

                <!-- <el-form-item label="使用模版:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择使用模版" v-model="input4" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList3"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item> -->


                <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnss">添加模版</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                </div>

            </el-form>


            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
                <el-table-column prop="createName" label="添加人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="模版名称" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="content" label="使用模版" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                            <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                            <el-button type="text" style="color:red;" @click="handleClickView('删除', scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-size="pageSize"
                layout="prev, pager, next,sizes, jumper" :total="total">
            </el-pagination>




        <div class="box"  v-if="ShowAddTemplateDialog">
        
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowAddTemplateDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ShowAddTemplateDialogTltie}}</div>
            </div>

            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;display: flex;">
               <div style="width:20%;border-right: 2px solid #EBEEF5;overflow-y: auto;">
                    <div style="margin-top: 10px;padding-top: 10px;">
                        <el-input v-model="valusName" :disabled="disabled" style="width: 80%;height: 35px;line-height: 2px;"></el-input>
                    </div>
               </div>
               <div style="width:80%;overflow: auto;" :class="disabled ? 'no-click' : '' ">
                   <vue-components  v-if="showComponents" v-model="content"></vue-components>
               </div>
            </div>

            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                <span slot="footer" class="dialog-footer">
                    <el-button size="small"  @click="handleShowAddTemplateDialogClose">取 消</el-button>
                    <el-button size="small" v-if="!disabled"  type="primary" @click="handleShowAddTemplateDialogSub">确 定</el-button>
                </span>
            </div>

        </div>   


    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";


export default {
    
    data(){
        return{

            valusName:'邮箱模版',

            input1: '',
            input2: [],
            input3: '',
            input4: '',
            optionList1: [],
            optionList2: [],
            optionList3: [],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            dataList: [],


            ShowAddTemplateDialog: false,
            ShowAddTemplateDialogTltie: '添加模版',

            content: '',
            showComponents:true,

            disabled:false,


            types:'初始化',
            templateId:'',


        }
    },

    mounted(){

        this.handleGetApiAll()

    },


    methods:{

        handleGetApiAll(){
            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
               this.optionList1 = res.data.data
               this.optionList2 = res.data.data
               this.optionList3 = res.data.data
            })

            // this.dataList = [{ addPeople:'岁岁平岁岁安·岁岁平安', addTime:'2024-05-10', TemplateName:'邮箱模版', applyTemplate:'是' }]

            this.handleGeiApiFindTemplatePage()

        },


        handleGeiApiAddTemplate(){
            let data = {  name: this.valusName,   content: this.content, }
            let types = this.types === '初始化' ? 'addTemplate' : 'modifyTemplate/' + this.templateId
            axios.post(`${apiBaseUrl}/template/${types}`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                   this.$message({type: 'success', message: '添加成功'})
                   this.handleGeiApiFindTemplatePage()
                   this.showComponents = false
                   this.ShowAddTemplateDialog = false
               }else{
                   this.$message({type: 'error', message: '添加失败' })
               }
            })
        },


        handleGeiApiFindTemplatePage(){
            let data = {  name: this.input3, pageNum: this.pageNum,  pageSize: this.pageSize , createId: this.input1, createStartDate: this.input2.length > 0 ? this.input2[0] : '', createEndDate: this.input2.length > 0 ? this.input2[1] : ''}
            axios.post(`${apiBaseUrl}/template/findTemplatePage`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                    let data = res.data.data
                    this.dataList = data.records
                    this.total = data.total
                    this.pageSize = data.size
                    this.pageNum = data.current
                    this.$message({type: 'success', message: '查询成功'})
               }else{
                    this.$message({type: 'error', message: '查询失败' })
               }
            })
        },



        handleAddCilckTemplate(type){
            if(type === '邮箱模版'){
              
            }
        },

        AddexportBtnss(){
            this.types = '初始化'
            this.ShowAddTemplateDialog = true
            this.showComponents = true
        },



        handleShowAddTemplateDialogClose(){
            this.showComponents = false
            this.ShowAddTemplateDialog = false
        },


        handleShowAddTemplateDialogSub(){
            this.handleGeiApiAddTemplate()
        },


        searchBtns(){
            this.handleGeiApiFindTemplatePage()
        },

        clearBtns(){
            this.input1 = ''
            this.input2 = []
            this.input3 = ''
            this.input4 = ''
            this.pageNum = 1
            this.pageSize  = 10

            this.handleGeiApiFindTemplatePage()
        },

        handleClickView(type,row){
            console.log(row)
            let { templateId, name, content, id } = row
            
            if(type === '详情'){
               this.types = '详情'
               this.disabled = true
               this.showComponents = true
               this.ShowAddTemplateDialog = true
               this.content = content
               this.templateId = templateId

            }
            if(type === '编辑'){
               this.types = '编辑'
               this.disabled = false
               this.showComponents = true
               this.ShowAddTemplateDialog = true
               this.content = content
               this.templateId = templateId
               this.valusName = name

            }
            if(type === '删除'){
                this.$confirm('此操作将永久删除模版, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.delete(`${apiBaseUrl}/template/deleteTemplate/${id ? id : row.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                        if(res.data.code == 200){
                            this.$message({type: 'success', message: '删除成功'})
                            this.handleGeiApiFindTemplatePage()
                        }else{
                            this.$message({type: 'error', message: '删除失败' })
                        }
                    })
                }).catch(() => {

                })
            }
        },

        handleCurrentChange(Current){
            this.pageNum = Current
            this.handleGeiApiFindTemplatePage()
        },

        handleSizeChange(Size){
            this.pageSize = Size
            this.handleGeiApiFindTemplatePage()
        },


    },



}


</script>

<style lang="less" scoped>

    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }

    .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }

   /deep/ .ql-blank{
        height: 75vh;
   }

   .no-click {
      pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/InterviewManagement/templateSettings.vue